<div class="row">
    <div class="col-10">
        <!-- <input ngx-google-places-autocomplete type="text" class="form-control" placeholder="Search..." -->
        <!-- #placesRef="ngx-places" (onAddressChange)="handleAddressChange($event)" /> -->
        <!-- <dx-text-box label="location"></dx-text-box> -->
        <label>Please enter location from search box and select location.</label>
        <input type="text" class="form-control" (keydown.enter)="$event.preventDefault()"
            placeholder="Search Nearest Location" autocorrect="off" autocapitalize="off" spellcheck="off" type="text"
            #search />
    </div>
    <div class="col-2 d-flex align-items-end">
        <dx-button type="secondary" class="w-100 h-100" (onClick)="getLocation()">
            <i class="fa fa-check"></i>
        </dx-button>
    </div>
</div>

<hr>
<form action="">
    <div class="row mb-1">
        <div class="col-6">
            <dx-text-box label="Building Name" [(value)]="name"></dx-text-box>
        </div>
        <div class="col-6">
            <dx-text-box label="Building No."></dx-text-box>
        </div>
    </div>

    <div class="row mb-1">
        <div class="col-6">
            <dx-text-box label="Street Name" [(value)]="streetName"></dx-text-box>
        </div>
        <div class="col-6">
            <dx-text-box label="Street No." [(value)]="streetNumber"></dx-text-box>
        </div>
    </div>

    <div class="row mb-1">
        <div class="col-6">
            <dx-text-box label="City/Suburb" [(value)]="locality"></dx-text-box>
        </div>
        <div class="col-6">
            <dx-text-box label="State" [(value)]="state"></dx-text-box>
        </div>
    </div>

    <div class="row mb-1">
        <div class="col-6">
            <dx-text-box label="Country" [(value)]="country"></dx-text-box>
        </div>
        <div class="col-6">
            <dx-text-box label="Zipcode" [(value)]="zipcode"></dx-text-box>
        </div>
    </div>
</form>

<div class="row mt-4">
    <div class="col-6"><dx-button class="w-100 h-100" type="success" text="Done"
            (onClick)="onSaveHandler()"></dx-button></div>
    <div class="col-6"><dx-button class="w-100 h-100" type="danger" text="Cancel" (onClick)="cancel()"></dx-button></div>
</div>